import Axios, { InternalAxiosRequestConfig } from 'axios';
import { env } from '../config/env';
import { getStorageItem } from '../lib/localStorage';
import { StorageKeys } from '../enums/StorageKeys.enum';
import { logout } from '../utils';

//* Attach auth headers to requests here
function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  if (config.headers) {
    config.headers.Accept = 'application/json';
  }

  //! This is for testing purposes
  config.headers['Access-Control-Allow-Origin'] = '*';
  config.headers['Access-Control-Allow-Methods'] =
    'GET, POST, PUT, DELETE, OPTIONS';

  //* Unauthenticated paths
  //! Please edit these as necessary
  const nonAuthPaths = ['/'];
  const currentApiPath = config.url ?? '';
  if (nonAuthPaths.includes(currentApiPath)) {
    return config;
  }

  //* Authenticated paths
  const jwt = getStorageItem(StorageKeys.token);
  if (jwt) {
    config.headers.Authorization = `Bearer ${jwt}`;
  }
  return config;
}

export const api = Axios.create({
  baseURL: env.API_BASE_URL + `/admin`,
});

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(
  (response) => {
    return response.data;
  },
  (error) => {
    console.error('api error.response', error.response);

    if (error.message === 'Network Error') {
      return Promise.reject(error);
    }

    //* This is the redirect logic for production
    if (error.response?.status === 401) {
      logout();
    }

    if (error.response?.status === 500) {
      return Promise.reject({ message: 'Something went wrong...' });
    }

    if (typeof error.response.data?.error === 'string') {
      return Promise.reject({ message: error.response.data.error });
    }

    return Promise.reject({ message: 'Something went wrong...' });
  }
);
